
	import { Component, Vue } from 'vue-property-decorator';
	import { serverProps } from '@/Common/Environment/const';

	@Component({})
	export default class NavBarAnonymous extends Vue {
		protected state: APS.IServerProps = serverProps;

		protected onLocaleChange(displayLang: string): void {
			if (displayLang === this.languageMenu?.currentDisplayLang) {
				return;
			}

			const searchParams = new URLSearchParams(window.location.search);
			const locale = this.languageMenu?.items.find((lang) => lang.displayLang === displayLang);

			if (!locale) {
				// eslint-disable-next-line no-console
				console.error(`No locale '${displayLang}' found!`);
			} else {
				searchParams.set('locale', `${locale?.localeLang}_${locale?.localeCountry}`);
				window.location.search = searchParams.toString();
			}
		}

		protected get computedStyle(): Partial<CSSStyleDeclaration> {
			return {
				minWidth: this.state.isXSClientType ? '' : '1140px'
			};
		}

		protected get error404(): boolean {
			return !!this.state.error404;
		}

		protected get isXSClientType(): boolean {
			return this.state.isXSClientType;
		}

		protected get signIn(): APS.ISignIn | undefined {
			return this.state.signIn;
		}

		protected get languageMenu(): APS.ILanguageMenu | undefined {
			return this.state.languageMenu;
		}

		protected get contextPath(): string {
			return this.state.contextPath;
		}

		protected get viewParams(): APS.IViewParams {
			return this.state.viewParams;
		}

		protected get isMDClientType(): boolean {
			return this.state.isMDClientType;
		}
	}
